'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Footer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Footer.__proto__ || Object.getPrototypeOf(Footer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showPartnerSitesForMobile: false,
      showInternationalSitesForMobile: false
    }, _this.partnerSitesClickHandler = function (event) {
      _this.setState({
        showPartnerSitesForMobile: !_this.state.showPartnerSitesForMobile
      });
    }, _this.internationalSitesClickHandler = function (event) {
      _this.setState({
        showInternationalSitesForMobile: !_this.state.showInternationalSitesForMobile
      });
    }, _this.render = function () {

      return _react2.default.createElement(
        'footer',
        null,
        _react2.default.createElement(
          'div',
          { className: 'footer-container' },
          _react2.default.createElement(
            'div',
            { className: 'social-and-legal' },
            _react2.default.createElement(
              'div',
              { className: 'social' },
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { target: '_blank', href: 'https://www.facebook.com/realcommercial', title: 'realcommercial.com.au Facebook', className: 'facebook' },
                    _react2.default.createElement(
                      'svg',
                      { xmlns: 'http://www.w3.org/2000/svg', className: 'icon', viewBox: '0 0 40 40' },
                      _react2.default.createElement('path', { d: 'M29.1 22.3l1.1-7.2h-6.9v-4.7c0-2 1-3.9 4.1-3.9h3.1v-6S27.7 0 24.9 0c-5.7 0-9.4 3.4-9.4 9.7v5.5H9.2v7.2h6.3v17.4c1.3.2 2.6.3 3.9.3 1.3 0 2.6-.1 3.9-.3V22.3h5.8z', fillRule: 'evenodd', clipRule: 'evenodd', fill: 'currentColor' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { target: '_blank', href: 'https://twitter.com/realcommercial', title: 'realcommercial.com.au Twitter', className: 'twitter' },
                    _react2.default.createElement(
                      'svg',
                      { xmlns: 'http://www.w3.org/2000/svg', className: 'icon', viewBox: '0 0 40 40' },
                      _react2.default.createElement('path', { d: 'M12.6 35.9C27.7 35.9 36 23.4 36 12.5v-1.1c1.6-1.2 3-2.6 4.1-4.3-1.5.6-3 1.1-4.7 1.3 1.7-1 3-2.6 3.6-4.5-1.6.9-3.3 1.6-5.2 2-1.5-1.6-3.6-2.6-6-2.6-4.5 0-8.2 3.7-8.2 8.2 0 .6.1 1.3.2 1.9-6.9-.3-13-3.6-17-8.5C2.1 6.1 1.7 7.5 1.7 9c0 2.8 1.4 5.4 3.7 6.8-1.3 0-2.6-.4-3.7-1v.1c0 4 2.8 7.3 6.6 8.1-.7.2-1.4.3-2.2.3-.5 0-1-.1-1.5-.2 1 3.3 4.1 5.6 7.7 5.7-3 2.2-6.5 3.5-10.3 3.5-.7 0-1.3 0-2-.1 3.6 2.3 7.9 3.7 12.6 3.7z', fillRule: 'evenodd', clipRule: 'evenodd', fill: 'currentColor' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { target: '_blank', href: 'https://www.linkedin.com/company/rea-group', title: 'realcommercial.com.au LinkedIn', className: 'linkedin' },
                    _react2.default.createElement(
                      'svg',
                      { xmlns: 'http://www.w3.org/2000/svg', className: 'icon', viewBox: '0 0 40 40' },
                      _react2.default.createElement('path', { d: 'M14.2 13.3h7.9V17h.1c1.1-2.1 3.8-4.3 7.8-4.3 8.4 0 9.9 5.5 9.9 12.7V40h-8.3V27c0-3.1-.1-7.1-4.3-7.1-4.3 0-5 3.4-5 6.9V40H14V13.3zM4.8 0c2.7 0 4.8 2.2 4.8 4.8 0 2.7-2.2 4.8-4.8 4.8C2.1 9.6 0 7.5 0 4.8 0 2.2 2.1 0 4.8 0zM.7 40H9V13.3H.7V40z', fillRule: 'evenodd', clipRule: 'evenodd', fill: 'currentColor' })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'legal' },
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'https://agent.realcommercial.com.au/build-your-brand/subscriptions', target: '_blank', title: 'Advertise with us' },
                    'Advertise with us'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'https://www.realcommercial.com.au/static/rca/about-us/', target: '_blank', title: 'About us' },
                    'About us'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'https://secure.realestate.com.au/sign_in', target: '_blank', title: 'Agent administration' },
                    'Agent admin'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'https://www.realcommercial.com.au/static/rca/contact-us/', target: '_blank', title: 'Agent administration' },
                    'Contact us'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'https://www.realcommercial.com.au/static/rca/acceptable-use-policy/', target: '_blank', title: 'Terms and conditions' },
                    'Terms and conditions'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'https://www.realcommercial.com.au/static/rca/legal/', target: '_blank', title: 'Legal' },
                    'Legal'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'https://www.realcommercial.com.au/static/rca/privacy/', target: '_blank', title: 'Privacy' },
                    'Privacy'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'https://www.rea-group.com/careers/', target: '_blank', title: 'Careers' },
                    'Careers'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'https://www.realcommercial.com.au/sitemap/', target: '_blank', title: 'Site map' },
                    'Site map'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: 'https://www.realcommercial.com.au/mobile/', target: '_blank', title: 'Mobile apps' },
                    'Mobile apps'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'sites' },
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                { className: 'group-corporate' },
                _react2.default.createElement(
                  'a',
                  { className: 'group-corporate', href: 'https://www.rea-group.com', target: '_blank', title: 'REA group corporate website' },
                  _react2.default.createElement(
                    'span',
                    null,
                    'REA Group Corporate Website'
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'real-estate' },
                _react2.default.createElement(
                  'a',
                  { className: 'real-estate', href: 'https://www.realestate.com.au', target: '_blank', title: 'Real estate to buy and rent' },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Real Estate to Buy and Rent'
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { className: 'real-commercial', href: '/' },
                  _react2.default.createElement('img', {
                    src: 'https://realcommercial.com.au/listing-ui-assets/img/rca-logo-white.svg?v=2',
                    alt: 'Real commercial',
                    title: 'Commercial property for sale and lease'
                  }),
                  _react2.default.createElement(
                    'span',
                    null,
                    'Search for Commercial Real Estate'
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'spacely' },
                _react2.default.createElement(
                  'a',
                  { className: 'spacely', href: 'https://www.realcommercial.com.au/short-term-workspace/', target: '_blank', title: 'Search for short term or shared spaces' },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Search for Spacely Real Estate'
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'flatmates' },
                _react2.default.createElement(
                  'a',
                  { className: 'flatmates', href: 'https://www.flatmates.com.au/', target: '_blank', title: 'Australia\'s biggest share accommodation site' },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Australia\'s biggest share accommodation site'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'sites-box' },
            _react2.default.createElement(
              'div',
              { onClick: _this.internationalSitesClickHandler, className: 'sites-box-title' },
              'International sites',
              _react2.default.createElement(
                'span',
                { className: (0, _classnames2.default)(["section-fold-button", _this.state.showInternationalSitesForMobile ? "arrow-up" : "arrow-down"]) },
                _react2.default.createElement(
                  'svg',
                  { xmlns: 'http://www.w3.org/2000/svg', className: 'icon', viewBox: '0 0 40 40' },
                  _react2.default.createElement('path', { d: 'M20 31.5c-.2 0-.5-.1-.7-.3l-19-19c-.4-.4-.4-1 0-1.3s1-.4 1.3 0L20 29.2l18.4-18.4c.4-.4 1-.4 1.3 0s.4 1 0 1.3l-19 19c-.2.3-.5.4-.7.4z', fill: 'currentColor' })
                )
              )
            ),
            _react2.default.createElement(
              'ul',
              { className: _this.state.showInternationalSitesForMobile ? "mobile-section-expand" : "mobile-section-collapse" },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.squarefoot.com.hk/', title: 'Property for sale and rent in Hong Kong' },
                  'Hong Kong'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.realestate.co.nz/?arcn&rsf=globalnav', title: 'Property for sale and rent in New Zealand' },
                  'New Zealand'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.myfun.com/', title: 'Property for sale and rent in China' },
                  'China'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.move.com/', title: 'move.com' },
                  'Move Inc'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.realtor.com/', title: 'Find Real Estate, Homes for Sale, Apartments & Houses for Rent - realtor.com\xAE' },
                  'realtor.com'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.iproperty.com/', title: 'iProperty.com : Asia\'s Leading Online Property Group' },
                  'iProperty'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://www.housing.com/', title: 'Property for sale and rent in India' },
                  'India'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'sites-box last-site-box' },
            _react2.default.createElement(
              'div',
              { onClick: _this.partnerSitesClickHandler, className: 'sites-box-title' },
              'Partner sites',
              _react2.default.createElement(
                'span',
                { className: (0, _classnames2.default)(["section-fold-button", _this.state.showPartnerSitesForMobile ? "arrow-up" : "arrow-down"]) },
                _react2.default.createElement(
                  'svg',
                  { xmlns: 'http://www.w3.org/2000/svg', className: 'icon', viewBox: '0 0 40 40' },
                  _react2.default.createElement('path', { d: 'M20 31.5c-.2 0-.5-.1-.7-.3l-19-19c-.4-.4-.4-1 0-1.3s1-.4 1.3 0L20 29.2l18.4-18.4c.4-.4 1-.4 1.3 0s.4 1 0 1.3l-19 19c-.2.3-.5.4-.7.4z', fill: 'currentColor' })
                )
              )
            ),
            _react2.default.createElement(
              'ul',
              { className: _this.state.showPartnerSitesForMobile ? "mobile-section-expand" : "mobile-section-collapse" },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.news.com.au/', target: '_blank', title: 'Latest news' },
                  'news.com.au'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.theaustralian.com.au/', target: '_blank', title: 'The Australian | Latest Australian National and Business News' },
                  'The Australian'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.property.com.au/', target: '_blank', title: 'Search for property to buy and rent' },
                  'Property For Sale'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.myfun.com/', target: '_blank', title: 'myfun.com' },
                  'China'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.couriermail.com.au/', target: '_blank', title: 'The Courier Mail' },
                  'Courier Mail'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.heraldsun.com.au/', target: '_blank', title: 'Herald Sun' },
                  'Herald Sun'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'http://apnarm.com.au/', target: '_blank', title: 'APN ARM' },
                  'Australian Regional Media'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.wsj.com/', target: '_blank', title: 'The Wall Street Journal' },
                  'Wall Street Journal'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.makaan.com/', target: '_blank', title: 'makaan.com' },
                  'makaan.com'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'a',
                  { href: 'https://www.proptiger.com/', target: '_blank', title: 'proptiger.com' },
                  'proptiger.com'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'copyright' },
            _react2.default.createElement(
              'p',
              null,
              'realcommercial.com.au is owned and operated by ASX-listed REA Group Ltd (REA:ASX) \xA9 REA Group Ltd.'
            )
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Footer;
}(_react2.default.Component);

exports.default = Footer;